import { faPen } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { formatError } from 'components/utils/FormatData';
import { useAlert } from 'react-alert';
import { useHistory } from 'react-router';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

import { URL_API } from '../../constants/settings';
import MyButton from '../form/MyButton';
import MyDialog from '../form/MyDialog';

const ActionCommandRenderer = (props) => {
  const alert = useAlert();
  const [content, setContent] = useState('');
  const [chooseCommand, setChooseCommand] = useState();
  const [dialogState, setDialogState] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (dialogState) {

      axios({ method: 'delete', url: URL_API + '/commandes-references/' + chooseCommand.id })
        .then(function () {
          alert.success('La commande [' + chooseCommand.commande + '] a été supprimée avec succès');
          props.setNeedUpdate(true);
        })
        .catch(function (err) {
          formatError(alert, err);
        });

      setChooseCommand(null);
      setDialogState(null);
    }
  }, [dialogState]);

  const handleEditCommand = () => {
    history.push('/parametres/gestion-commandes-references/edition/' + props.data.id);
  }
  const handleDeleteCommand = () => {
    if (props.data) {
      setChooseCommand(props.data);
      setContent(`Êtes-vous sur de vouloir supprimer la commande suivante : ${props.data.commande}`);
      setOpenDialog(true);
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      <MyButton className="classic-button" type="button" href="#" iconCenter={{ icon: faPen, type: 'fontAwesome' }}
        styleCss={{ boxShadow: 'none', color: props.wsStatus ? '#0c86b3' : '#8ca0a8', height: '25px', padding: '6px', cursor: props.wsStatus ? 'cursor' : 'default' }}
        onClick={() => props.wsStatus ? handleEditCommand() : null} />
      <MyButton className="classic-button" type="button" href="#" iconCenter={{ icon: faTrash, type: 'fontAwesome' }}
        styleCss={{ boxShadow: 'none', color: props.wsStatus ? '#BB0060' : '#8ca0a8', height: '25px', padding: '6px', cursor: props.wsStatus ? 'cursor' : 'default' }}
        onClick={() => props.wsStatus ? handleDeleteCommand() : null} />

      <MyDialog open={openDialog} handleClose={setOpenDialog} title="Suppression commande" content={content} dialog={setDialogState} />
    </div>
  );

};

export default ActionCommandRenderer;